module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0